export enum RoutingPath {
  ApAdministrators = '/AP/Administrators',
  ApAppsDomains = '/AP/Apps/Domains',
  ApAppsDomainusers = '/AP/Apps/DomainUsers',
  ApAppsGeneral = '/AP/Apps/General',
  ApArchivePreview = '/AP/ArchivePreview',
  ApAuditLog = '/AP/AuditLog',
  ApAssets = '/AP/Assets',
  ApBackupComputers = '/AP/Backup/Computers',
  ApBackupHistory = '/AP/BackupHistory',
  ApBackupHistoryLegacy = '/AP/BackupHistoryLegacy',
  ApBackupTemplates = '/AP/BackupTemplates',
  ApBackupTemplatesHistory = '/AP/BackupTemplates/history',
  ApBranding = '/AP/Branding',
  ApCalc = '/AP/calc.aspx',
  ApChangeTracker = '/AP/ChangeTracker',
  ApCompanies = '/AP/Companies',
  ApComputers = '/AP/Computers',
  ApConnectWiseNew = '/AP/ConnectWiseNew',
  ApDashboard = '/AP/Dashboard',
  ApDefaultAspx = '/AP/Default.aspx',
  ApDocuments = '/AP/Documents',
  ApEmailService = '/AP/EmailService',
  ApGettingStart = '/AP/GettingStart',
  ApStayLoggedIn = '/AP/StayLoggedIn',
  ApGettingStartRMM = '/AP/GettingStart/RMM',
  ApGettingStartTryRMM = '/AP/GettingStart/TryRMM',
  ApGlobalAgentOptions = '/AP/GlobalAgentOptions',
  ApHaloPSA = '/AP/HaloPSA',
  ApHelp = '/AP/Help',
  ApLicenses = '/AP/Licenses',
  ApLicensesAspx = '/AP/Licenses.aspx',
  ApLoginMcp = '/AP/LoginMcp',
  ApMonitoring = '/AP/Monitoring',
  ApNewBackupHistory = '/AP/newBackupHistory',
  ApNewBackupHistoryDetails = '/AP/newBackupHistory/details',
  ApNewMonitoring = '/AP/Monitoring',
  ApNotFound = '/AP/NotFound',
  ApNotifications = '/AP/Notifications',
  ApPlanReportSettings = '/AP/PlanReportSettings',
  ApPremiumSupport = '/AP/PremiumSupport',
  ApPurchaseHistory = '/AP/PurchaseHistory',
  ApRDStatistics = '/AP/RDStatistics',
  ApRMMAlertsHistory = '/AP/RMMAlertsHistory',
  ApRMMComputers = '/AP/RMM/Computers',
  ApRMMGroupTaskAction = '/AP/RMMGroupTaskAction',
  ApRMMPage = '/AP/RMMPage',
  ApRestoreToCloud = '/AP/RestoreToCloud',
  ApScheduledReports = '/AP/ScheduledReports',
  ApSettings = '/AP/Settings',
  ApSnmp = '/AP/Snmp',
  ApSSL = '/AP/SSL',
  ApStorageCapacityReport = '/AP/StorageCapacityReport',
  ApStorageUsage = '/AP/StorageUsage',
  ApStorages = '/AP/StorageAccounts',
  ApBackupStorage = '/AP/BackupStorage',
  ApTickets = '/AP/Tickets',
  ApTicketSettings = '/AP/TicketSettings',
  ApUserListAspx = '/AP/UserList.aspx',
  ApUsers = '/AP/Users',
  ApVmConsole = '/AP/VMConsole',
  Connect = 'WebConnect',
  EmailsCustomization = '/AP/EmailsCustomization',
  EnableTFA = '/AS/Enable2FA',
  Login = '/AS/Login',
  LoginAspx = 'Login.aspx',
  LoginUser = '/AS/LoginUser',
  LoginAdmin = '/AS/LoginAdmin',
  AuthorizationComputer = '/AP/AuthorizationComputer',
  Maintenance = 'AP/Maintenance',
  NewWebConsoleRebranding = '/AP/NewWebConsoleRebranding',
  NotificationErrors = '/AP/NotificationErrors',
  OnlineAccess = '/OnlineAccess',
  OnlineAccessNotFound = '/NotFound',
  RestorePassword = '/AS/RestorePassword',
  RMMAlertCustomisation = 'AP/RMMAlertCustomisation',
  RMMAPITokens = '/AP/RMMApiTokens',
  RMMNotifications = '/AP/RMMNotifications',
  RMMScriptLibrary = '/AP/ScriptLibrary',
  SignUp = '/AS/SignUp',
  StorageLimits = '/AP/StorageLimits',
  SupportPortal = '/AP/SupportPortal',
  Unauthorized = '/AS',
  WebConsoleRebranding = '/AP/WebConsoleRebranding'
}
